import { render } from "./EstadisticasEncuesta.vue?vue&type=template&id=fdfb1ee6"
import script from "./EstadisticasEncuesta.vue?vue&type=script&lang=js"
export * from "./EstadisticasEncuesta.vue?vue&type=script&lang=js"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__